module.exports = "/images/tm.svg?00c480254b345d79670fc9f4e036c6ae";